import { AxiosRequestConfig, AxiosError } from 'axios';
import { Gateway } from 'index';

export const getVatCheck = async (vat: string, config?: AxiosRequestConfig) => {
  try {
    const response = await Gateway.get<{ format_valid: boolean; message: string }>(
      `/vat-check/v1/check/${vat}`,
      config
    );
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw error;
    }
    throw new AxiosError();
  }
};
